import { AuthLayout, Content } from './components';
import { useLazyGetMovesQuery, profileApi } from './api/profile.api';

export { AuthLayout, useLazyGetMovesQuery, profileApi };

export default Content;
